import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { MessageService } from 'primeng/api';

interface ToastMessageOptions {
  summary?: string;
  detail?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private messageService: MessageService) {}

  info(message: ToastMessageOptions) {
    this.messageService.add({
      severity: 'info',
      ...message,
    });
  }

  success(message: ToastMessageOptions) {
    this.messageService.add({
      severity: 'success',
      ...message,
    });
  }

  error(message: ToastMessageOptions) {
    this.messageService.add({
      severity: 'error',
      ...message,
    });
  }

  httpError(error: HttpErrorResponse) {
    if (error.error.payload?.content && Object.keys(error.error.payload.content).length > 0) {
      Object.entries(error.error.payload.content).forEach(([key, value]: any) => {
        this.error({
          summary: error.error.message,
          detail: value,
        });
      });
    } else {
      this.error({
        summary: error.error.message || error.message,
      });
    }
  }
}
